import "@/App.css";
import { useState, useEffect } from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/contexts/AuthContext";
import { Toaster } from "sonner";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import Home from "@/pages/Home";
import Properties from "@/pages/Properties";
import PropertyDetail from "@/pages/PropertyDetail";
import About from "@/pages/About";
import Contact from "@/pages/Contact";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import AdminListings from "@/pages/AdminListings";
import AdminListingForm from "@/pages/AdminListingForm";
import AdminInquiries from "@/pages/AdminInquiries";

function ProtectedRoute({ children }) {
  const { user, loading, checkAuth } = useAuth();
  const [checking, setChecking] = useState(false);

  useEffect(() => {
    if (!loading && !user && localStorage.getItem("k10_token") && !checking) {
      setChecking(true);
      checkAuth().finally(() => setChecking(false));
    }
  }, [loading, user, checkAuth, checking]);

  if (loading || checking) return (
    <div className="min-h-screen flex items-center justify-center bg-[#F4F6FA]">
      <div className="w-8 h-8 border-2 border-[#32A334] border-t-transparent rounded-full animate-spin" />
    </div>
  );
  if (!user && !localStorage.getItem("k10_token")) return <Navigate to="/admin/login" replace />;
  if (!user) return (
    <div className="min-h-screen flex items-center justify-center bg-[#F4F6FA]">
      <div className="w-8 h-8 border-2 border-[#32A334] border-t-transparent rounded-full animate-spin" />
    </div>
  );
  return children;
}

function PublicLayout({ children }) {
  return (
    <>
      <Header />
      <main className="min-h-screen">{children}</main>
      <Footer />
    </>
  );
}

function AdminLayout({ children }) {
  return (
    <div className="min-h-screen bg-[#F4F6FA]">
      <Header isAdmin />
      <main className="pt-20">{children}</main>
    </div>
  );
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster
          theme="light"
          position="top-right"
          toastOptions={{
            style: { background: '#FFFFFF', border: '1px solid #E2E8F0', color: '#1A1A2E' }
          }}
        />
        <Routes>
          {/* Public */}
          <Route path="/" element={<PublicLayout><Home /></PublicLayout>} />
          <Route path="/properties" element={<PublicLayout><Properties /></PublicLayout>} />
          <Route path="/properties/:slug" element={<PublicLayout><PropertyDetail /></PublicLayout>} />
          <Route path="/about" element={<PublicLayout><About /></PublicLayout>} />
          <Route path="/contact" element={<PublicLayout><Contact /></PublicLayout>} />

          {/* Admin */}
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={<ProtectedRoute><AdminLayout><AdminDashboard /></AdminLayout></ProtectedRoute>} />
          <Route path="/admin/listings" element={<ProtectedRoute><AdminLayout><AdminListings /></AdminLayout></ProtectedRoute>} />
          <Route path="/admin/listings/new" element={<ProtectedRoute><AdminLayout><AdminListingForm /></AdminLayout></ProtectedRoute>} />
          <Route path="/admin/listings/:id/edit" element={<ProtectedRoute><AdminLayout><AdminListingForm /></AdminLayout></ProtectedRoute>} />
          <Route path="/admin/inquiries" element={<ProtectedRoute><AdminLayout><AdminInquiries /></AdminLayout></ProtectedRoute>} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
